<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }" class="table-search-container">
      <bread-crumb :style="{ float: 'left' }" />
      <a-input-search
        placeholder="请输入搜索内容"
        style="width: 225px; margin-top: 19px; float: right"
        @search="onSearch"
      />
      <a-select
        placeholder="请选择合作企业"
        v-model="company_id"
        style="
          width: 225px;
          margin: 19px 23px 0;
          float: right;
          border-radius: 15px;
        "
        @change="(value) => onChangecompany(value)"
      >
        <a-select-option
          v-for="item in companyData"
          :key="item.id"
          :value="item.id"
        >
          {{ item.companyInfo.qichacha_name }}
        </a-select-option>
      </a-select>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: (total) => `共${total}条`,
        }"
        @change="changePage"
      >
        <template slot="work_plan_title" slot-scope="text">
          <a-tooltip placement="bottomLeft" :title="text" color="#13c2c2">
            <span class="ellipsis" style="width: 200px">{{ text }}</span>
          </a-tooltip>
        </template>
        <template slot="status" slot-scope="status">
          {{ status | agreement($store.state.user.role) }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <span>
            <a v-if="record.status === 5" @click="handlePreview(record)"
              >预览</a
            >

            <!-- <a-divider
              v-if="record.status===5"
              type="vertical"
            /> -->
            <!-- <a
              v-if="record.status===5"
              href="javascript:;"
              @click="() => handleLoad(record)"
            >下载PDF</a> -->
            <a-divider v-if="record.status === 5" type="vertical" />
            <a
              v-if="record.status === 5"
              href="javascript:;"
              @click="() => handleLoadWord(record)"
              >下载报告</a
            >
            <a-divider v-if="record.status === 5" type="vertical" />
          </span>
          <span v-if="$store.state.user.role === 1">
            <a
              v-if="record.status === 1"
              href="javascript:;"
              @click="() => handleAllocation(record)"
              >分配</a
            >
            <a
              v-if="record.status !== 1"
              href="javascript:;"
              @click="() => action(record)"
              >查看</a
            >

            <!-- 第二次及以上的调整推广人分配 -->
            <a-divider v-if="record.status === 2" type="vertical" />
            <a
              v-if="record.status === 2"
              href="javascript:;"
              @click="() => handleDeployAction(record)"
              >调配</a>
          </span>
          <span v-else>
            <popconfirm-button
              v-show="record.status === 3"
              text="验收"
              alert-title="确定验收？"
              @onDelete="() => onConfirm(record)"
            />
            <a-divider v-show="record.status === 3" type="vertical" />
            <a href="javascript:;" @click="() => action(record)">查看</a>
          </span>
        </template>
      </a-table>
    </div>

    <!-- 分配任务 -->
    <allocation-modal
      ref="allocationRef"
      :data="allocationData"
      :title="title"
      :visible="allocationVisible"
      @onCancel="onCancelAllocation"
      @onSubmit="onSubmitAllocation"
    />

    <!-- 调配任务 -->
    <deploy-modal
      ref="deployRef"
      :data="deployData"
      :title="title"
      :visible="deployVisible"
      @onCancel="onCancelDeploy"
      @onSubmit="onDeploySubmit"
    />

    <!-- 预览报告 -->
    <preview-report-modal
      ref="previewReportRef"
      :previewSrc="previewSrc"
      :visible="previewReportVisible"
      @onCancel="onCancelPreview"
    />
  </div>
</template>
<script>
import { columns } from "./data/index";
import Utils from "./utils/getStatus.js";
import AllocationModal from "./modal/allocationModal";
import DeployModal from "./modal/deployModal";
import PreviewReportModal from "./modal/previewReportModal";
export default {
  // 状态获取
  filters: {
    agreement(val, role) {
      return Utils.getStatus(role, val);
    },
  },
  components: { AllocationModal, DeployModal, PreviewReportModal },
  data() {
    return {
      company_id: "",
      companyData: [],
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      allocationData: {},
      title: "任务详情",
      allocationVisible: false,
      previewReportVisible: false,
      previewSrc: "",
      operations: [],
      token: "",
      listId: "",
      count: 0,
      // 调配参数
      deployVisible: false,
      deployData:{}
    };
  },
  mounted() {
    // 获取表格数据
    this.getCompanyList();
    this.token = localStorage.getItem("token");
  },
  methods: {
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
        this.company_id = this.companyData[0].id;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          cooperation_company_id: this.company_id,
        });
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post("/WorkList/getList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;

        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            work_plan_title: item.work_plan_title,
            province: `${item.work_plan.agreement_info.province_txt} ${item.work_plan.agreement_info.city_txt}`,
            name: item.work_plan.agreement_info.company_info.companyInfo
              .qichacha_name,
            service_title: item.service_title,
            flag: item.flag,
            plan_num: item.plan_num,
            create_num: item.create_num || 0,
            pass_num: item.pass_num || 0,
            total_money: item.total_money,
            plan_start_time: this.$moment
              .unix(item.plan_start_time)
              .format("YYYY-MM-DD"),
            plan_end_time: this.$moment
              .unix(item.plan_end_time)
              .format("YYYY-MM-DD"),
            status: item.status,
            operations: Utils.getOperation(
              this.$store.state.user.role,
              item.status
            ),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // // 操作
    action(record, operationName) {
      this.$router.push({
        path: "/list/details",
        query: { status: record.status, id: record.id, flag: record.flag },
      });
    },
    // 调配推广人-弹窗
    handleDeployAction(record) {
      console.log("handleDeployAction -> record", record);
      this.deployVisible = true;
      this.$refs.deployRef.form.resetFields();
      this.deployData = record;
      this.listId = record.id;
      this.count = record.plan_num;
    },
    // 调配推广人-关闭弹窗
    onCancelDeploy(){
      this.deployVisible = false;
    },
    // 分配
    handleAllocation(record) {
      console.log("handleAllocation -> record", record);
      this.allocationVisible = true;
      this.$refs.allocationRef.form.resetFields();
      this.allocationData = record;
      this.listId = record.id;
      this.count = record.plan_num;
    },
    // 取消分配
    onCancelAllocation() {
      this.allocationVisible = false;
    },
    // 关闭预览窗口
    onCancelPreview() {
      this.previewReportVisible = false;
    },
    onSubmitAllocation() {
      this.$refs.allocationRef.form.validateFields(async (err, values) => {
        console.log("TCL: onReportRejectSubmit -> values", values);
        if (!err) {
          this.allocationVisible = true;
          let value = [];
          Object.values(values).forEach((item, index) => {
            // 去掉姓名
            item.uid = item.uid.substr(0, item.uid.indexOf('_'));
            if (typeof item === "object") {
              value.push({ ...item, key: Object.keys(values)[index] });
            }
          });
          let assign_list = {
            assign_list: value,
            id: this.listId,
          };
          let count = 0;
          assign_list.assign_list.forEach((item) => {
            count = count + item.assigned_num;
          });
          if (count !== this.count) {
            this.$message.warning("分配工作量需要和工作总量相等！");
            return;
          }
          let result = await this.$http.post("/WorkList/assign", {
            ...assign_list,
          });
          this.btnIsLoadingReject = false;
          if (result.data.status === 1) {
            this.allocationVisible = false;
            this.$message.success("操作成功！");
            // 获取清单数据
            this.getTableData({
              keyword: this.keyword,
              page: this.current,
              pageSize: String(this.pageSize),
              cooperation_company_id: this.company_id,
            });
          }
        }
      });
    },
    // 保存调配任务
    onDeploySubmit() {
      this.$refs.deployRef.form.validateFields(async (err, values) => {
        if (!err) {
          let value = [];
          Object.values(values).forEach((item, index) => {
            // 去掉姓名
            item.uid = item.uid.substr(0, item.uid.indexOf('_'));
            if (typeof item === "object") {
              value.push({ ...item, key: Object.keys(values)[index] });
            }
          });

          let assign_list = {
            assign_list: value,
            id: this.listId,
          };

          let result = await this.$http.post("/WorkList/deploy", {
            ...assign_list,
          });

          if (result.data.status === 1) {
            this.deployVisible = false;
            this.$message.success("操作成功！");
            // 获取清单数据
            this.getTableData({
              keyword: this.keyword,
              page: this.current,
              pageSize: String(this.pageSize),
              cooperation_company_id: this.company_id,
            });
          }
        }
      });
    },
    // 验收
    async onConfirm(record) {
      let result = await this.$http.post("/WorkList/verify", { id: record.id });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        // 获取清单数据
        this.getTableData({
          keyword: this.keyword,
          page: this.current,
          pageSize: String(this.pageSize),
          cooperation_company_id: this.company_id,
        });
      }
    },
    onChangecompany(value) {
      this.current = 1;
      this.company_id = value;
      this.getTableData({
        keyword: this.keyword,
        page: this.current,
        pageSize: String(this.pageSize),
        cooperation_company_id: this.company_id,
      });
    },
    // 搜索
    onSearch(value) {
      this.keyword = value;
      this.current = 1;
      // 获取表格数据
      this.getTableData({
        keyword: this.keyword,
        page: this.current,
        pageSize: String(this.pageSize),
        cooperation_company_id: this.company_id,
      });
    },
    // 预览  下载
    handlePreview(record) {
      this.previewReportVisible = true;
      this.previewSrc = `${this.uploadUrl}WorkList/preview?work_list_id=${record.id}&token=${this.token}`;

      console.log("this.previewSrc===>", this.previewSrc);

      // window.open(
      //   `${this.uploadUrl}WorkList/preview?work_list_id=${record.id}&token=${this.token}`,
      //   "_blank",
      //   "scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=700,height=700"
      // );
    },
    handleLoad(record) {
      window.open(
        `${this.uploadUrl}WorkList/downloadPdf?work_list_id=${record.id}&token=${this.token}`
      );
    },
    handleLoadWord(record) {
      console.log(record);
      window.open(
        `${this.uploadUrl}WorkReport/workReportExportWord?agreement_id=${record.data.work_plan.agreement_id}&work_plan_id=${record.data.work_plan.id}&service_id=${record.data.s_id}&token=${this.token}`
      );
    },

    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        keyword: this.keyword,
        page: this.current,
        pageSize: pagination.pageSize,
        cooperation_company_id: this.company_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
